<span class="type-icon" [ngClass]="[originClass, compact ? 'is-compact' : '']">
  <fa-icon [icon]="icon"></fa-icon>
</span>
